<a href="javascript:;" (click)="close()" class="close-btn"><i class="far fa-times"></i></a>
<div class="modal-body">
  <img src="/assets/images/acm/promo/dashboard/icon2.webp" height="138" alt="" />
  <div class="top-badge">
    <img src="/assets/images/acm/promo/blink-green.webp" height="13" alt="" /> Advanced Features Available
  </div>
  <h4 class="text-dark font-weight-bold" style="font-size: 18px">Unlock the Full Power of Your PMS</h4>
  <div class="text-center" style="font-weight: 500">
    <div>Discover powerful tools in AdvanceCM</div>
    <div>that automate operations, improve guest communication, and increase revenue.</div>
  </div>
  <div class="d-flex flex-column w-100" style="gap: 0.5rem">
    <div
      class="d-flex align-items-center p-2 feature-item bg-white"
      style="gap: 1rem"
      (click)="goToACM('/automations')"
      matTooltip="Explore 'Autopilot' on AdvanceCM"
    >
      <img src="/assets/images/acm/promo/dashboard/autopilot.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Autopilot</span> - Scheduled messages and automated workflows.</div>
      <div class="ml-auto item-action-icon">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
    <div
      class="d-flex align-items-center p-2 feature-item bg-white"
      style="gap: 1rem"
      (click)="goToACM('/inquiries/inbox')"
      matTooltip="Explore 'Unified Inbox' on AdvanceCM"
    >
      <img src="/assets/images/acm/promo/dashboard/inbox.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Unified Inbox</span> — Email, WhatsApp, SMS and social in one place.</div>
      <div class="ml-auto item-action-icon">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
    <div
      class="d-flex align-items-center p-2 feature-item bg-white"
      style="gap: 1rem"
      (click)="goToACM('/reviews')"
      matTooltip="Explore 'Advanced Reviews' on AdvanceCM"
    >
      <img src="/assets/images/acm/promo/dashboard/review.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Advanced Reviews</span> — Track ratings with AI-assisted replies.</div>
      <div class="ml-auto item-action-icon">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
    <div
      class="d-flex align-items-center p-2 feature-item bg-white"
      style="gap: 1rem"
      (click)="goToACM('/devices')"
      matTooltip="Explore 'Smart Devices' on AdvanceCM"
    >
      <img src="/assets/images/acm/promo/dashboard/lock.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Smart Devices</span> — Monitor locks, alerts, and devices remotely.</div>
      <div class="ml-auto item-action-icon">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
    <div
      class="d-flex align-items-center p-2 feature-item bg-white"
      style="gap: 1rem"
      (click)="goToACM('/security-deposits')"
      matTooltip="Explore 'Security Deposits' on AdvanceCM"
    >
      <img src="/assets/images/acm/promo/dashboard/dollar.webp" height="32" alt="" />
      <div><span class="font-weight-bold">Security Deposits</span> — Collect and manage deposits automatically.</div>
      <div class="ml-auto item-action-icon">
        <i class="fal fa-angle-right"></i>
      </div>
    </div>
  </div>
</div>
